import { useNavigate } from "react-router-dom";
import Button from "@mui/material/Button";
import Box from "@mui/material/Box";

import { useSnackbar } from "../../contexts/SnackbarProvider";
import { useAuth } from "../../contexts/AuthContext";
import TextField from "@mui/material/TextField";

const Login = () => {
  const { setSnackbarDetail } = useSnackbar();
  const { authenticateUser } = useAuth();
  const navigate = useNavigate();

  async function loginUser(e) {
    e.preventDefault();

    authenticateUser(e.target.username.value, e.target.password.value)
      .then((res) => {
        setSnackbarDetail({
          open: true,
          message: "login successful",
          severity: "success",
        });
        navigate("/");
      })
      .catch((error) => {
        setSnackbarDetail({
          open: true,
          message: "user login failed",
          severity: "error",
        });
      });
  }

  return (
    <>
      <Box
        component="form"
        onSubmit={loginUser}
        sx={{
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <TextField
          variant="outlined"
          id="username"
          label="username"
          placeholder="username"
          sx={{ width: "300px" }}
        />

        <TextField
          variant="outlined"
          type="password"
          id="password"
          label="password"
          placeholder="password"
          sx={{ m: 2, width: "300px" }}
        />

        <Button
          type="submit"
          variant="contained"
          color="primary"
          sx={{ width: "300px" }}
        >
          Login
        </Button>
      </Box>
    </>
  );
};

export default Login;
